import { useContext } from "react";
import { LangContext, LangContextType } from "../utilities/customHooks";
import textData from "../textData.json";
import { Alert, AlertTitle, AlertDescription } from "./ui/alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

interface ErrorIndicatorProps {
  onRetry?: () => void;
}

function ErrorIndicator({ onRetry }: ErrorIndicatorProps) {
  const { langState } = useContext(LangContext) as LangContextType;

  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <Alert variant="destructive" className="max-w-md">
        <FontAwesomeIcon icon={faCircleExclamation} className="h-4 w-4" />
        <AlertTitle>
          {langState === "eng" ? "Something went wrong" : "Une erreur est survenue"}
        </AlertTitle>
        <AlertDescription className="mt-1">
          {textData.Components.ErrorIndicator.Error[langState]}
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 block text-sm font-medium underline underline-offset-4 hover:opacity-80"
            >
              {langState === "eng" ? "Try again" : "Réessayer"}
            </button>
          )}
        </AlertDescription>
      </Alert>
    </div>
  );
}

export default ErrorIndicator;
